/**
 * ══════════════════════════════════════════════════════════════════════════
 * "İLGİLENMİYORUM" — TEK AKIŞ (kararlar + olay sözleşmesi)
 *
 * ── ÖLÇÜLEN DURUM (bu tur, değiştirmeden ÖNCE) ───────────────────────────
 * Sinyalin kullanıcı girişi ZATEN VARDI — ama **İKİ TANE** ve ikisi farklı
 * davranıyordu:
 *
 *  A) Rail → "Daha Fazla" sayfası → "İlgilenmiyorum"
 *     (`EngagementRailV3.onNotInterestedClick`)
 *     · giriş yapılmamışsa "Giriş yap" toast'u
 *     · "Daha az gösterilecek" toast'u + **5 sn GERİ AL** penceresi
 *     · pencere dolunca `mlv3:not-interested` yayınlar → FeedContainerV3 yazar
 *
 *  B) Kart → uzun-bas bağlam menüsü → "İlgilenilmiyor"
 *     (`FeedCardImmersive.handleNotInterestedClick`)
 *     · ANINDA Firestore'a yazıyordu — geri alma YOK
 *     · **hiçbir geri bildirim YOK** (dosyanın kendi yorumu bunu itiraf
 *       ediyordu: *"toast göstermek için … erişim yok; sessizce yutuyoruz"*)
 *     · üstüne `recordNegativeFeedback` (küme demote) da çağırıyordu
 *
 * Yani IG'nin bilinen zayıflığı (*"kullanıcı kontrolü hissi zayıf"*) bu
 * depoda **yarısında** tekrarlanıyordu: A yolu IG'den iyiydi, B yolu IG'den
 * kötüydü. Ve hangi yola bastığını kullanıcı seçmiyor — uzun-bas mı, menü mü,
 * ikisi de aynı cümleyi vaat ediyor.
 *
 * ── BU TURUN KARARI ──────────────────────────────────────────────────────
 * Yeni bir üçüncü yol AÇILMAZ. B yolu, A yolunun **tetikleyicisine** dönüşür:
 * kart bir İSTEK yayınlar, rail (o klibin sahibi bileşen) kendi kanonik
 * akışını çalıştırır. Böylece her iki giriş de aynı şeyi verir: giriş
 * kontrolü · görünür geri bildirim · 5 sn geri alma · TEK yazım.
 *
 * `recordNegativeFeedback` de artık ONAY olayına bağlanır → "Geri Al"a basan
 * kullanıcı küme demote'unu da geri almış olur (eskiden geri alınamıyordu).
 *
 * ── KENDİ KLİBİ ──────────────────────────────────────────────────────────
 * Kendi klibin için "ilgilenmiyorum" anlamsız (kendi içeriğini kendi
 * akışından gizlemek ayrı bir iştir) ve sinyali kirletir → satır GİZLENİR.
 * Karar tek yerde (`niSatiriGorunur`), iki yüzey de onu çağırır.
 *
 * ── MALİYET (ölçüldü) ────────────────────────────────────────────────────
 * Firestore şeması, yolu, kuralı ve indeksi **DEĞİŞMEDİ**:
 * `viewerEngagementHistory/{uid}/clips/{clipId}` — yazan tek yer yine
 * `notInterestedClient.markNotInterested`. Bu tur SIFIR yeni yazım, SIFIR
 * yeni sorgu, SIFIR yeni indeks üretir; aksine B yolundaki anında-yazım
 * artık 5 sn geri-alma penceresine tabi olduğu için **yazım sayısı düşer**
 * (vazgeçilen her dokunuş bir yazımdan tasarruf).
 * ══════════════════════════════════════════════════════════════════════════
 */

/**
 * Kart yüzeyinden rail'e giden İSTEK. Yazım YAPMAZ — yalnız kanonik akışı
 * (giriş kontrolü + toast + geri alma) tetikler.
 */
export const NI_ISTEK_OLAYI = "mlv3:not-interested-request";

/**
 * Geri-alma penceresi dolunca yayınlanan ONAY. **Mevcut sözleşme** —
 * `FeedContainerV3` bunu dinleyip Firestore'a yazar; adı DEĞİŞMEDİ.
 */
export const NI_ONAY_OLAYI = "mlv3:not-interested";

/**
 * "İlgilenmiyorum" satırı gösterilsin mi? TEK KARAR NOKTASI.
 *
 * Kendi klibinde gizlenir. Anonim kullanıcıda GÖSTERİLİR — dokununca
 * "Giriş yap" geri bildirimi almak, satırın hiç olmamasından iyidir
 * (satırı gizlemek kullanıcıya *neden* olmadığını anlatmaz).
 */
export function niSatiriGorunur(opts?: {
  isOwnClip?: boolean | null;
} | null): boolean {
  return !opts?.isOwnClip;
}

/**
 * Klibin sahibi izleyicinin kendisi mi? `useClipEngagement.canRepost` ile
 * AYNI ölçüt — tek yerde yazılsın diye burada.
 */
export function kendiKlibiMi(
  viewerUid: string | null | undefined,
  authorUid: string | null | undefined,
): boolean {
  return !!viewerUid && !!authorUid && String(viewerUid) === String(authorUid);
}

/**
 * Gelen istek BU klibe mi ait? (Her kartta bir rail var; yalnız hedef rail
 * tepki vermeli — aksi halde tek dokunuş N klibi işaretlerdi.)
 */
export function niIstegiBanaMi(
  detail: unknown,
  clipId: string | null | undefined,
): boolean {
  const id = clipId == null ? "" : String(clipId);
  if (!id) return false;
  if (!detail || typeof detail !== "object") return false;
  const gelen = (detail as { clipId?: unknown }).clipId;
  return gelen != null && String(gelen) === id;
}

/**
 * Kart yüzeyinden isteği yayınla. `false` = yayınlanmadı (geçersiz id ya da
 * DOM yok) → çağıran taraf sessiz kalmaz, kendi dalını sürdürebilir.
 */
export function niIstegiGonder(clipId: string | null | undefined): boolean {
  const id = clipId == null ? "" : String(clipId).trim();
  if (!id) return false;
  if (typeof window === "undefined") return false;
  try {
    window.dispatchEvent(
      new CustomEvent(NI_ISTEK_OLAYI, { detail: { clipId: id } }),
    );
    return true;
  } catch {
    return false;
  }
}
